<script setup lang="ts">
import { computed, ref } from 'vue';
import { Input } from '@/components/ui/input';
import { arrayItemName } from '@/components/arrayColumns/arrayItemName';

const props = defineProps<{
  field: string;
  dataType: string;
  data: any;
  classType: string;
}>();

const filterText = ref('');

// Get the children array data
// Field pattern: 'albums.display_string' where 'albums' is the array field
const childrenArray = computed(() => {
  const parts = props.field.split('.');
  if (parts.length !== 2 || parts[1] !== 'display_string') {
    return [];
  }
  const arrayField = parts[0];
  const arrayData = props.data[arrayField];
  return Array.isArray(arrayData) ? arrayData : [];
});

// Get display strings from children array
const childrenDisplayStrings = computed(() => {
  if (!childrenArray.value || childrenArray.value.length === 0) {
    return [];
  }
  return childrenArray.value
    .map((item: unknown) => arrayItemName(item, props.classType))
    .filter((str: string) => str !== '');
});

// Filter display strings based on filter text
const filteredDisplayStrings = computed(() => {
  if (!filterText.value.trim()) {
    return childrenDisplayStrings.value;
  }
  const searchText = filterText.value.toLowerCase();
  return childrenDisplayStrings.value.filter((str: string) =>
    str.toLowerCase().includes(searchText)
  );
});
</script>

<template>
  <div class="flex flex-col flex-1 min-h-0 overflow-hidden">
    <!-- Filter section with input -->
    <div class="py-3 border-b px-4">
      <Input
        v-model="filterText"
        placeholder="Filter items..."
      />
    </div>
    <!-- Scrollable list -->
    <div class="flex-1 min-h-0 overflow-y-auto px-4">
      <div v-if="filteredDisplayStrings.length > 0" class="p-2">
        <div
          v-for="(displayString, index) in filteredDisplayStrings"
          :key="index"
          class="px-3 py-2 text-sm break-words hover:bg-muted rounded-md"
        >
          {{ displayString }}
        </div>
      </div>
      <div v-else class="px-3 py-6 text-center text-muted-foreground text-sm">
        No items found
      </div>
    </div>
  </div>
</template>
